/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';

// atoms
import Trophy from '../../../atoms/icons/trophy';
import Title from '../../../atoms/title';
import Subtitle from '../../../atoms/subtitle';
import Button from '../../../atoms/button';

// molecules
import StoreBadges from '../../../molecules/storeBadges';

// style
import './style.scss';

export default () => {
  return (
    <>
      <Trophy />
      <Title>Tudo certo!</Title>
      <Subtitle className="subtitle-small">
        Agora você pode aproveitar <strong>todos os conteúdos de GZH</strong> e
        economizar com o Clube do Assinante.
      </Subtitle>
      <Button to="https://gauchazh.clicrbs.com.br/" external>
        Acessar GZH
      </Button>
      <StoreBadges />
    </>
  );
};
